export default (ctx, inject) => {
	const dataURLToBlob = (dataURL) => {
		let BASE64_MARKER = ';base64,'
		let parts, contentType, raw, rawLength
		if (dataURL.indexOf(BASE64_MARKER) === -1) {
			parts = dataURL.split(',')
			contentType = parts[0].split(':')[1]
			raw = parts[1]

			return new Blob([raw], { type: contentType })
		}

		parts = dataURL.split(BASE64_MARKER)
		contentType = parts[0].split(':')[1]
		raw = window.atob(parts[1])
		rawLength = raw.length

		let uInt8Array = new Uint8Array(rawLength)

		for (let i = 0; i < rawLength; ++i) {
			uInt8Array[i] = raw.charCodeAt(i)
		}

		return new Blob([uInt8Array], { type: contentType })
	}

	const imageResize = async ({ file, max_size }) => {
		if (!file.type.match(/image.*/)) return null

		let blob = await (new Promise(resolve => {
			let reader = new FileReader();
			reader.onload = (readerEvent) => {
				let image = new Image()
				image.onload = () => {

					// Resize the image
					let canvas = document.createElement('canvas'),
						reduce = 1, context, dataUrl, newSize

					do {
						canvas.width = image.width * reduce
						canvas.height = image.height * reduce
						context = canvas.getContext('2d')
						context.drawImage(image, 0, 0, image.width * reduce, image.height * reduce)
						dataUrl = canvas.toDataURL('image/jpeg', reduce)
						newSize = dataUrl.split(',')[1].replace(/=/g, '').length * 0.75

						context.clearRect(0, 0, canvas.width, canvas.height)
						reduce -= 0.1
					} while (newSize > (max_size || 204800) && reduce >= 0.1)

					let resizedImage = dataURLToBlob(dataUrl)
					resolve(resizedImage)
				}
				image.src = readerEvent.target.result
			}
			reader.readAsDataURL(file)
		}))

		return blob
	}
	inject('imageResize', imageResize)
}
